import axios from 'axios';
import BaseApi from './base';
import {
    GET_NOTIFICATIONS,
    DELETE_NOTIFICATION,
    DELETE_ALL_NOTIFICATIONS,
} from '@/constants/api';

export default class extends BaseApi {
    static get() {
        return axios.get(GET_NOTIFICATIONS);
    }

    static delete(id) {
        return axios.get(DELETE_NOTIFICATION + '/' + id);
    }

    static deleteAll() {
        return axios.get(DELETE_ALL_NOTIFICATIONS);
    }
}